import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { DialogEntityInfoDialog, ISSelectComponent } from './is-select.component';
import { MatMenuModule } from '@angular/material/menu';
import { MatIconModule } from '@angular/material/icon';
import { MatTooltipModule } from '@angular/material/tooltip';
import { MatDialogModule } from '@angular/material/dialog';
import { ReactiveFormsModule } from '@angular/forms';
import { SharedModule } from '../shared.module';
import { NgbModule } from '@ng-bootstrap/ng-bootstrap';

const materialModules = [
    MatIconModule,
    MatTooltipModule,
    MatDialogModule
];

@NgModule({
    declarations: [ISSelectComponent, DialogEntityInfoDialog],
    imports: [
        CommonModule,
        MatMenuModule,
        SharedModule,
        ReactiveFormsModule,
        NgbModule,
        ...materialModules
    ],
    exports: [ISSelectComponent],
    providers: [],
})
export class ISSelectModule {}